export default {"src":"/_next/static/media/pinenuts.e7305e73.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};